/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // VARIAVEL PARA GERAR URL DAS SALAS DE CONFERENCIA
  URL_ROOMS_LINK: 'https://reuniao0800.vipsolutions.com.br/meet/',
  URL_VIDEO_SERVER: 'meet3.vipsolutions.com.br',
  URL_BACKEND_SERVER: 'https://reuniao0800-24293810862.us-central1.run.app/reuniao'
};
